<template>
  <b-form-group
    label="Açıklama"
    label-for="notes"
  >
    <validation-provider
      #default="{ errors }"
      name="Açıklama"
      rules="required"
    >
      <b-form-input
        id="notes"
        v-model="dataList[keyNumber].notes"
        placeholder="Açıklama"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'NotesText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  props: {
    keyNumber: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dataList() {
      return this.$store.getters['productCalories/dataList']
    },
  },
}
</script>
